module.exports = __webpack_public_path__ + "img/arrow_next.1bea5905.svg";